import type { TournamentDrawType } from 'types/tournament';

const newCompetition = (newFitId: string) => {
  const url = `https://www.fitp.it/Tornei/Dettaglio-Competizione?competitionId=${newFitId}#`;
  return url;
};

const championship = (newFitId: string) => {
  const url = `https://www.fitp.it/Tornei/Campionato-a-squadre-dettagli?competitionId=${newFitId}`;
  return url;
};

const draw = (fitDrawId: string | undefined, tournament: TournamentDrawType | undefined) =>
  `https://www.fitp.it/Tornei/Areas/Federtennis/Scripts/Puc/Tabellone_v2?tournamentId=${tournament?.new_fit_tournament_id}&phaseId=${fitDrawId}`;

const fitPlayerUrl = (cardNumber: string) => `https://management.federtennis.it/vt?k=${cardNumber}&y=CT`;

const getMethodLink = (year: number | undefined) => {
  switch (year) {
    case 2021:
      return 'https://www.fitp.it/media/File_pdf/20201216_Metodo_per_la_definizione_delle_classifiche_federali_2022.pdf';
    case 2022:
      return 'https://www.fitp.it/media/FIT/Federtennis/Tornei_e_Classifiche/Campionati_Nazionali/20211216_2023_metodo_per_la_definizione_delle_classifiche_federali_v3_1.pdf';
    case 2023:
      return 'https://www.fitp.it/media/FIT/Federtennis/Tornei_e_Classifiche/Campionati_Nazionali/20221206_2024_Metodo_per_la_definizione_delle_classifiche_federali.pdf';
    case 2024:
      return 'https://www.fitp.it/media/FIT/Federtennis/Tornei_e_Classifiche/Campionati_Nazionali/Giovanili_a_squadre/20240715_2025_Metodo_per_la_definizione_delle_classifiche_federali_V2.pdf';
    case 2025:
      return 'https://www.fitp.it/media/FIT/Federtennis/Tornei_e_Classifiche/Campionati_Nazionali/20241129_2026_Metodo_per_la_definizione_delle_classifiche_federali_V2.pdf';
    default:
      return 'https://www.fitp.it/media/FIT/Federtennis/Tornei_e_Classifiche/Campionati_Nazionali/20251112_2027_Metodo_per_la_definizione_delle_classifiche_federali_V3..pdf';
  }
};

export default {
  draw,
  fitPlayerUrl,
  newCompetition,
  championship,
  getMethodLink,
};
